import type { PayrollRunInfo } from '../types';

/** What the payroll journal's form holds (wave 5 §2.2): the run, and a figure per payroll line as typed. */
export interface PayrollForm {
  kind: PayrollRunInfo['kind'];
  periodStart: string;
  periodEnd: string;
  figures: Record<string, string>;
}

export const EMPTY_PAYROLL: PayrollForm = { kind: 'regular', periodStart: '', periodEnd: '', figures: {} };

/** The form as a saved journal holds it: its run, and its line figures. */
export function payrollFormFrom(run: PayrollRunInfo | null | undefined, figures: Record<string, number | null> | null | undefined): PayrollForm {
  return {
    kind: run?.kind === 'contractor' ? 'contractor' : 'regular',
    periodStart: run?.periodStart ?? '',
    periodEnd: run?.periodEnd ?? '',
    figures: Object.fromEntries(Object.entries(figures ?? {}).map(([k, v]) => [k, v == null ? '' : String(v)])),
  };
}

/** The run as the server takes it. */
export const payrollRunOf = (form: PayrollForm): PayrollRunInfo => ({
  kind: form.kind,
  periodStart: form.periodStart || null,
  periodEnd: form.periodEnd || null,
});
